import { emitter } from 'shared/helpers/mitt';
import { BUS_EVENTS } from 'shared/constants/busEvents';

export const isMessagingBlockActive = contact => {
  if (!contact) return false;

  if (contact.messaging_block_active !== undefined) {
    return contact.messaging_block_active;
  }

  if (contact.messagingBlockActive !== undefined) {
    return contact.messagingBlockActive;
  }

  if (!contact.blocked) return false;

  const until = contact.blocked_until || contact.blockedUntil;
  if (!until) return true;

  return new Date(until) > new Date();
};

export const isContactBlockUpdate = contact =>
  Boolean(
    contact &&
    ('blocked' in contact ||
      'blocked_until' in contact ||
      'messaging_block_active' in contact ||
      'messagingBlockActive' in contact ||
      'blockedUntil' in contact)
  );

export const emitContactBlockUpdated = contact => {
  if (!isContactBlockUpdate(contact)) return;

  emitter.emit(BUS_EVENTS.CONTACT_UPDATED, contact);
};

export const normalizeContactId = contact => Number(contact?.id);

export const removeContactFromList = ($state, contactId) => {
  const normalizedId = Number(contactId);
  const index = $state.sortOrder.findIndex(id => Number(id) === normalizedId);

  if (index === -1) return;

  $state.sortOrder.splice(index, 1);
  if ($state.meta.count > 0) {
    $state.meta.count -= 1;
  }
};

export const syncBlockedListMembership = ($state, contact) => {
  if (!contact?.id) return;

  if (!isMessagingBlockActive(contact)) {
    removeContactFromList($state, contact.id);
  }
};

export const mergeContactRecord = ($state, data) => {
  const contactId = Number(data.id);
  const existing = $state.records[contactId] || $state.records[data.id] || {};
  const merged = { ...existing, ...data, id: contactId };

  $state.records[contactId] = merged;

  return merged;
};
